<template lang='pug'>

.actionList
  template(v-for='history in histories')
    .date
      h1 {{ showDate(history.date) }}
      template(v-for='data in history.data')
        .event
          header
            span.action {{ showActions(data.event.type) }}
            span.time {{ data.time }}
          span.message(v-html="showMessage(data)")
  .addlist
    el-button(v-if='displayMoreButton' size='mini' :loading='isEventlistLoading' @click='loadEvents()') {{ $t('Analysis.User.reload', {num:pageSize}) }}


</template>

<script>
import actions from '@/utils/defines/actions.js';
import dateFns from '@/utils/defines/date.js';
import API from '@/api/analytics';
import Vue from 'vue';

export default {
  data () {
    return {
      pageSize: 10,
      isEventlistLoading: false,
      eventHash: { },
      totalHistoryCount: 0
    }
  },
  props: ['device_name'],
  mixins: [actions, dateFns],
  computed: {
    histories() {
      const result = [ ];
      for (const day of Object.keys(this.eventHash).sort().reverse()) {
        result.push({
          date: new Date(day),
          data: this.eventHash[day]
        });
      }
      return result;
    },
    displayedHistoriesCount() {
      return Object.values(this.eventHash).reduce((a,v)=>a+=v.length, 0);
    },
    displayMoreButton() {
      return this.displayedHistoriesCount < this.totalHistoryCount;
    }
  },
  methods: {
    loadEvents: function(reload){
      const obj = this;
      const reqParams = {
        device: this.$route.params.nfc_uid,
        page_size: this.pageSize,
        page: reload ? 1 : this.currentPage + 1,
      };
      API.getDeviceEventList(reqParams).then(function(response) {
        if (response && response.device_event_list !== undefined) {
          obj.addEvents(response.device_event_list, reload);
          obj.currentPage = obj.currentPage + 1;
        } else {
          // show error or something?
        }
      });
      if (!!reload) {
        API.getDeviceEventCount(reqParams).then(function(response) {
          if (response && response.device_event_count !== undefined) {
            obj.setCount(response.device_event_count);
            obj.currentPage = 0;
          }
        });
      }
    },
    addEvents(hash, reset) {
      if (reset) {
        this.eventHash = hash;
      } else {
        for (const key of Object.keys(hash)) {
          if (this.eventHash[key] !== undefined) {
            this.eventHash[key].push(...hash[key]);
          } else {
            Vue.set(this.eventHash, key, hash[key]);
          }
        }
      }
    },
    setCount: function(count) {
      this.totalHistoryCount = count;
    },
    showDate: function(date){
      return this.getDate(date);
    },
    showActions: function(type){
      for(var i=0; i<this.actions.length; i++){
        if (this.actions[i].type == type){
          return this.$t(this.actions[i].name);
        }
      }
    },
    showMessage(data) {
      data.meta.device_name = this.device_name
      switch(data.meta.type){
        case "nth_touch" :
          if (data.meta.customer_id === '_unknown') {
            return this.$t('Analysis.Device.nth_touch_unknown', data.meta);
          }
          return this.$t('Analysis.Device.nth_touch', data.meta);
        default: return this.$t('Analysis.default')
      }
    }
  },
  mounted() {
    this.loadEvents(true);
  }
}
</script>

<style lang='scss' scoped>
@import '../../../styles/variables.scss';

.el-table ::v-deep {
  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0;
    color: #999;

  }
  td.logcell {
    padding: 5px 0;
    font-size: 13px;
  }
  .cell {
    padding-left: 2px;
  }
}

.actionList {

  .date {
    position: relative;

    &:before {
      content: '';
      background: $border;
      display: block;
      position: absolute;
      width: 100%;
      margin: 27px 0 0 0;
      height: 1px;
    }

    h1 {
      display: inline-block;
      position: relative;
      font-size: 14px;
      padding: 3px 8px;
      border: 1px solid $border;
      background: #FFF;
      border-radius: 20px;
      height: 20px;
      min-width: 120px;
      font-weight: normal;
      text-align: center;
    }
  }

  .event {
    transition: all .3s ease-in-out;
    padding: 5px 3px;
    &:hover {
      background: rgba(58,179,232,0.1);
      border-radius: 5px;

      header {
        background: $safe;
        box-shadow: 0 0 0 2px $safe;

        span.action {
          color: #FFF;
        }
      }
    }

    header {
      transition: all .3s ease-in-out;
      display: inline-block;
      text-align: center;
      background: $border;
      box-shadow: 0 0 0 2px $border;
      border-radius: 5px;
      margin: 0 10px 0 0;

      span {
        display: inline-block;
        font-size: 14px;

        &.action {
          transition: all .3s ease-in-out;
          line-height: 1;
          padding: 3px 6px;
          min-width: 120px;
        }
        &.time {
          padding: 3px 6px;
          border-radius: 5px;
          background: #FFF;
        }
      }
    }
    .message {
      font-size: 14px;
    }
  }

  .addlist {
    margin-top: 30px;
  }
}

a.user {
  color: $safe;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
